<template>
  <!-- Charts -->
  <b-row class="mt-0 charts">
    <b-col class="mb-4" lg="8" md="8" sm="8" v-if="isVisible(chartType.DISPATCHTREND)">
      <b-card no-body>
        <b-card-title class="pt-4 pl-4 pb-2 pr-4 chart-title">
          <router-link class="text-decoration-none" :to="isSuperAdmin ? '/admin/admin-dispatch' : '/dispatch'">
            <h5 class="mb-0">Dispatch Success Trend</h5>
          </router-link>
        </b-card-title>
        <b-card-body class="pb-0 pt-0">
          <BarWithLineChart :title="'Dispatch Success Trend'" :labels="metricsData.dispatchTrend.barData.labels"
            :barLabel="'No. of dispatches'" :lineLabel="'Success Rate (%)'"
            :barData="metricsData.dispatchTrend.barData.counts" :lineData="metricsData.dispatchTrend.lineData.counts" />
        </b-card-body>
      </b-card>
    </b-col>
    <b-col class="mb-4" lg="4" md="4" sm="4" v-if="isVisible(chartType.HIREDEHIRE)">
      <b-card no-body>
        <b-card-title class="pt-4 pl-4 pb-2 pr-4 chart-title">
          <v-select class="style-chooser asset-type-filter" label="text" placeholder=" - Asset Type - "
            :reduce="(assetType) => assetType.value" :options="filteredAssetTypes"
            v-model="filterBy.hireDehireAssetType">
            <template v-slot:no-options="{ search, searching }">
              <template v-if="searching">
                No results found for
                <em>
                  <strong>{{ search }}</strong>
                </em>
              </template>
              <em :style="{ opacity: 0.5 }" v-else>
                Start typing to search for a asset type
              </em>
            </template>
          </v-select>
          <router-link class="text-decoration-none" :to="isSuperAdmin ? '/admin/admin-dispatch' : '/dispatch'">
            <h5 class="mb-0">Hire Vs. Dehire</h5>
          </router-link>
        </b-card-title>
        <b-card-body class="pb-0 pt-0">
          <PieChart :title="'Hire Vs. Dehire'" :data="hireDehire" :labels="['Hires', 'Dehires']" />
        </b-card-body>
      </b-card>
    </b-col>

    <b-col class="mb-4" lg="12" md="12" sm="12" v-if="isVisible(chartType.DISPATCHINBOUND)">
      <b-card no-body>
        <b-card-title class="pt-4 pl-4 pb-2 pr-4 chart-title">
          <router-link class="text-decoration-none" :to="isSuperAdmin ? '/admin/admin-dispatch' : '/dispatch'">
            <h5 class="mb-0">Top Account based on No. of Dispatches (Inbound)</h5>
          </router-link>
        </b-card-title>
        <b-card-body class="pb-0 pt-0">
          <BarChart :title="'Top Account based on No. of Dispatches (Inbound)'"
            :data="metricsData.inboundAssetDispatch.counts" :labels="metricsData.inboundAssetDispatch.companies">
          </BarChart>
        </b-card-body>
      </b-card>
    </b-col>

    <b-col class="mb-4" lg="12" md="12" sm="12" v-if="isVisible(chartType.DISPATCHOUTBOUND)">
      <b-card no-body>
        <b-card-title class="pt-4 pl-4 pb-2 pr-4 chart-title">
          <router-link class="text-decoration-none" :to="isSuperAdmin ? '/admin/admin-dispatch' : '/dispatch'">
            <h5 class="mb-0">Top Account based on No. of Dispatches (Outbound)</h5>
          </router-link>
        </b-card-title>
        <b-card-body class="pb-0 pt-0">
          <BarChart :title="'Top Account based on No. of Dispatches (Outbound)'"
            :data="metricsData.outboundAssetDispatch.counts" :labels="metricsData.outboundAssetDispatch.companies">
          </BarChart>
        </b-card-body>
      </b-card>
    </b-col>

    <b-col class="mb-4" lg="8" md="8" sm="8" v-if="isVisible(chartType.ASSETSUMMARY)">
      <b-card no-body>
        <b-card-title class="pt-4 pl-4 pb-2 pr-4 chart-title">
          <v-select class="style-chooser asset-type-filter" label="text" placeholder=" - Asset Type - "
            :reduce="(assetType) => assetType.value" :options="filteredAssetTypes"
            v-model="filterBy.classificationAssetType">
            <template v-slot:no-options="{ search, searching }">
              <template v-if="searching">
                No results found for
                <em>
                  <strong>{{ search }}</strong>
                </em>
              </template>
              <em :style="{ opacity: 0.5 }" v-else>
                Start typing to search for a asset type
              </em>
            </template>
          </v-select>
          <router-link class="text-decoration-none" :to="isSuperAdmin ? '/admin/admin-dispatch' : '/dispatch'">
            <h5 class="mb-0">Asset Classification Summary</h5>
          </router-link>
        </b-card-title>
        <b-card-body class="pb-0 pt-0">
          <AssetSummaryChart :title="'Asset Classification Summary'" :data="assetClassification"
            :labels="['Good', 'Damaged', 'Others']" />
        </b-card-body>
      </b-card>
    </b-col>

    <b-col class="mb-4" lg="4" md="4" sm="4" v-if="isVisible(chartType.INCIDENTREPORT)">
      <b-card no-body>
        <b-card-title class="pt-4 pl-4 pb-2 pr-4 chart-title">
          <router-link class="text-decoration-none"
            :to="isSuperAdmin ? '/admin/admin-incident-report' : '/incident-report'">
            <h5 class="mb-0">Incident Report</h5>
          </router-link>
        </b-card-title>
        <b-card-body class="pb-0 pt-0">
          <BarChart :dataSetLabel="'No. of Reports'" :data="metricsData.incidentReportData.counts"
            :labels="metricsData.incidentReportData.labels" :title="'Incident Report'"></BarChart>
        </b-card-body>
      </b-card>
    </b-col>

    <b-col class="mb-4" lg="6" md="6" sm="6" v-if="isVisible(chartType.INVENTORYSKU)">
      <b-card no-body>
        <b-card-title class="pt-4 pl-4 pb-2 pr-4 chart-title">
          <router-link class="text-decoration-none"
            :to="isSuperAdmin ? '/admin/admin-asset-pool-distribution' : '/asset-pool-distribution'">
            <h5 class="mb-0">Asset Inventory Graph per SKU</h5>
          </router-link>
        </b-card-title>
        <b-card-body class="pb-0 pt-0">
          <PieChart :title="'Asset Inventory Graph per SKU'" :legendPosition="'right'"
            :data="metricsData.assetGraphSkuData.totals" :labels="metricsData.assetGraphSkuData.assetTypes" />
        </b-card-body>
      </b-card>
    </b-col>
    <b-col class="mb-4" lg="6" md="6" sm="6" v-if="isVisible(chartType.ACTIVEANDINACTIVECONNECTEDCOMPANIES)">
      <b-card no-body>
        <b-card-title class="pt-4 pl-4 pb-2 pr-4 chart-title">
          <router-link class="text-decoration-none" :to="isSuperAdmin ? '/admin/company' : '/company'">
            <h5 class="mb-0">No. of Active and Inactive connected Companies</h5>
          </router-link>
        </b-card-title>
        <b-card-body class="pb-0 pt-0">
          <PieChart :title="'No. of Active and Inactive connected Companies'"
            :data="metricsData.activeInactiveCompanyData" :labels="['Active', 'Inactive']" />
        </b-card-body>
      </b-card>
    </b-col>
    <b-col class="mb-4" lg="12" md="12" sm="12" v-if="isVisible(chartType.DEPOSITTRANSFER)">
      <b-card no-body>
        <b-card-title class="pt-4 pl-4 pb-2 pr-4 chart-title">
          <router-link class="text-decoration-none" :to="isSuperAdmin ? '/admin/admin-dispatch' : '/dispatch'">
            <h5 class="mb-0">Deposit Transfer Monitoring Analytics</h5>
          </router-link>
        </b-card-title>
        <b-card-body class="pb-0 pt-0">
          <BarChart :title="'Deposit Transfer Monitoring Analytics'" :data="metricsData.depositTransferData.counts"
            :labels="metricsData.depositTransferData.companies"></BarChart>
        </b-card-body>
      </b-card>
    </b-col>
    <b-col class="mb-4" lg="12" md="12" sm="12" v-if="isVisible(chartType.DELAYEDTRANSFER)">
      <b-card no-body>
        <b-card-title class="pt-4 pl-4 pb-2 pr-4 chart-title">
          <router-link class="text-decoration-none" :to="isSuperAdmin ? '/admin/admin-dispatch' : '/dispatch'">
            <h5 class="mb-0">Delayed Transfer Monitoring Analytics</h5>
          </router-link>
        </b-card-title>
        <b-card-body class="pb-0 pt-0">
          <BarChart :title="'Delayed Transfer Monitoring Analytics'" :data="metricsData.delayedTransferData.counts"
            :labels="metricsData.delayedTransferData.companies"></BarChart>
        </b-card-body>
      </b-card>
    </b-col>

    <b-col class="mb-4" lg="12" md="12" sm="12" v-if="isVisible(chartType.INVENTORYVOLUME)">
      <b-card no-body>
        <b-card-title class="pt-4 pl-4 pb-2 pr-4 chart-title">
          <v-select class="style-chooser asset-type-filter" label="text" placeholder=" - Asset Type - "
            :reduce="(assetType) => assetType.value" :options="filteredAssetTypes"
            v-model="filterBy.inventoryVolumeAssetType">
            <template v-slot:no-options="{ search, searching }">
              <template v-if="searching">
                No results found for
                <em>
                  <strong>{{ search }}</strong>
                </em>
              </template>
              <em :style="{ opacity: 0.5 }" v-else>
                Start typing to search for a asset type
              </em>
            </template>
          </v-select>
          <router-link class="text-decoration-none"
            :to="isSuperAdmin ? '/admin/admin-asset-pool-distribution' : '/asset-pool-distribution'">
            <h5 class="mb-0">Asset Inventory Volume</h5>
          </router-link>
        </b-card-title>
        <b-card-body class="pb-0 pt-0">
          <LineChart :title="'Asset Inventory Volume'" :labels="assetInventoryVolume.total.labels" :dataSets="[
            {
              label: 'Total Assets',
              data: assetInventoryVolume.total.counts,
              fill: false,
              backgroundColor: '#000',
            },
            {
              label: 'New Assets',
              data: assetInventoryVolume.new.counts,
              fill: false,
              backgroundColor: '#F3A8A5',
            },
          ]"></LineChart>
        </b-card-body>
      </b-card>
    </b-col>

    <b-col class="mb-4" lg="12" md="12" sm="12" v-if="isVisible(chartType.TRANSACTIONSDISCREPANCY)">
      <b-card no-body>
        <b-card-title class="pt-4 pl-4 pb-2 pr-4 chart-title">
          <router-link class="text-decoration-none"
            :to="isSuperAdmin ? '/admin/admin-discrepancy-reports' : '/discrepancy-reports'">
            <h5 class="mb-0">Total No. of Transactions w/ Discrepancies</h5>
          </router-link>
        </b-card-title>
        <b-card-body class="pb-0 pt-0">
          <BarChart :title="'Total No. of Transactions w/ Discrepancies'"
            :data="metricsData.transactionDiscrepancyData.counts"
            :labels="metricsData.transactionDiscrepancyData.labels">
          </BarChart>
        </b-card-body>
      </b-card>
    </b-col>
    <b-col class="mb-4" lg="12" md="12" sm="12" v-if="isVisible(chartType.ACCOUNTDISCREPANCY)">
      <b-card no-body>
        <b-card-title class="pt-4 pl-4 pb-2 pr-4 chart-title">
          <router-link class="text-decoration-none"
            :to="isSuperAdmin ? '/admin/admin-discrepancy-reports' : '/discrepancy-reports'">
            <h5 class="mb-0">Summary of Accounts w/ Discrepancies</h5>
          </router-link>
        </b-card-title>
        <b-card-body class="pb-0 pt-0">
          <BarChart :title="'Summary of Accounts w/ Discrepancies'" :data="metricsData.accountsDiscrepancyData.counts"
            :labels="metricsData.accountsDiscrepancyData.companies"></BarChart>
        </b-card-body>
      </b-card>
    </b-col>
  </b-row>
</template>
<script>
import config from "@/config/env-constants";
import _ from 'lodash'

export default {
  name: "configured-chart",
  components: {
    PieChart: () => import("@/views/commons/charts/PieChart"),
    BarChart: () => import("@/views/commons/charts/BarChart"),
    LineChart: () => import("@/views/commons/charts/LineChart"),
    BarWithLineChart: () => import("@/views/commons/charts/BarWithLineChart"),
    AssetSummaryChart: () => import("@/views/commons/charts/AssetSummaryChart"),
  },
  props: {
    metricsData: {
      type: Object,
      required: true,
    },
    chartOptions: {
      type: Array,
      required: true,
    },
    assetTypeOptions: {
      type: Array,
      required: true,
    },
    selectedCompany: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      chartType: config.chartType,
      filteredAssetTypes: [],
      filterBy: {
        inventoryVolumeAssetType: "",
        classificationAssetType: "",
        hireDehireAssetType: "",
      },
      isSuperAdmin: this.$store.getters.isSuperAdmin,
    };
  },
  watch: {
    chartOptions: {
      handler(newVal) {
      },
      deep: true,
      immediate: true,
    },
    metricsData: {
      handler(newVal) {
      },
      deep: true,
      immediate: true,
    },
    selectedCompany: {
      handler(newVal) {
        this.updateAssetTypeOptions(newVal);
      },
      deep: true,
      immediate: true,
    },
  },
  computed: {
    hireDehire() {
      let result = [0, 0];

      const items =
        this.filterBy.hireDehireAssetType && this.filterBy.hireDehireAssetType.name
          ? this.metricsData.hireDehireData[this.filterBy.hireDehireAssetType.name]
            ? [this.metricsData.hireDehireData[this.filterBy.hireDehireAssetType.name]]
            : result
          : Object.values(this.metricsData.hireDehireData);

      for (const hireDehireItem of items) {
        for (var x = 0; x < hireDehireItem.length; x++) {
          result[x] += hireDehireItem[x];
        }
      }

      return result;
    },

    assetClassification() {
      let good = 0;
      let damaged = 0;
      let others = 0;

      const items =
        this.filterBy.classificationAssetType &&
          this.filterBy.classificationAssetType.name
          ? this.metricsData.classificationSummaryData[
            this.filterBy.classificationAssetType.name
          ]
            ? [
              this.metricsData.classificationSummaryData[
              this.filterBy.classificationAssetType.name
              ],
            ]
            : [{ good: 0, damaged: 0, others: 0 }]
          : Object.values(this.metricsData.classificationSummaryData);

      for (var i = 0; i < items.length; i++) {
        good += items[i].good;
        damaged += items[i].damaged;
        others += items[i].others;
      }

      return [good, damaged, others];
    },

    assetInventoryVolume() {
      const defaultValue = {
        total: { labels: [], counts: [] },
        new: { labels: [], counts: [] },
      };

      const items =
        this.filterBy.inventoryVolumeAssetType &&
          this.filterBy.inventoryVolumeAssetType.name
          ? this.metricsData.inventoryVolumeData[
            this.filterBy.inventoryVolumeAssetType.name
          ]
            ? [
              this.metricsData.inventoryVolumeData[
              this.filterBy.inventoryVolumeAssetType.name
              ],
            ]
            : [...defaultValue]
          : Object.values(this.metricsData.inventoryVolumeData);

      if (items.length > 0) {
        defaultValue.total.labels = items[0].total.labels;
        defaultValue.new.labels = items[0].new.labels;
      }

      for (const key in items) {
        const current = items[key];

        ['total', 'new'].forEach(type => {
          const counts = current[type].counts;

          counts.forEach((count, i) => {
            defaultValue[type].counts[i] = (defaultValue[type].counts[i] || 0) + count;
          });
        });
      }

      return defaultValue;
    },
  },
  methods: {
    isVisible(chart) {
      return this.chartOptions.some((value) => value === chart);
    },
    updateAssetTypeOptions(companyId) {
      if (companyId !== null) {
        this.filteredAssetTypes = _.filter(this.assetTypeOptions, (o) => {
          return (
            o.value !== null && (o.value.originId === companyId || o.value.id === null)
          );
        });
      } else {
        this.filteredAssetTypes = [
          {
            value: { ...config.assetTypeDefaultValue },
            text: " - Please select - ",
          },
        ];
      }
    },
  },
};
</script>
<style>
.chart-title {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;

  h5:hover {
    color: blue;
    text-decoration: underline;
  }
}

.charts {
  .card {
    height: 100%;
  }
}

.asset-type-filter {
  width: 70%;
  cursor: pointer;
}
</style>